import {Component, EventEmitter, Input, OnDestroy, OnInit, Output} from "@angular/core";
import {DxAppError} from "../../../../dx-core/domain/error/dx-app-error";
import {DxAppEvent} from "../../../../dx-core/domain/events/dx-app-event";


/**
 * Форма отображения информации о фатальной ошибке, возникшей во время выполнения приложения.
 * @publicApi
 */
@Component({
  selector: '.dx-error-report',
  templateUrl: './dx-error-report.component.html',
  styleUrls: ['./dx-error-report.component.css']
})
export class DxErrorReportComponent implements OnInit, OnDestroy {
  /**
   * Искомый объект ошибки приложения.
   * @name _error
   * @type {DxAppError}
   */
  private _error: DxAppError;

  /**
   * Заголовок ошибки.
   * @name errorTitle
   * @type {string}
   */
  public errorTitle: string;

  /**
   * Сообщение из ошибки.
   * @name errorMessage
   * @type {string}
   */
  public errorMessage: string;

  /**
   * Флаг показать\скрыть кнопку "Вернуться в систему".
   * @name showGoBackBtn
   * @type {boolean}
   * @defaultValue - true
   */
  @Input()
  public showGoBackBtn: boolean = true;

  /**
   * Флаг показать\скрыть кнопку "Отправить отчет в техподдержку".
   * @name showSubmitErrorReportBtn
   * @type {boolean}
   * @defaultValue - true
   */
  @Input()
  public showSubmitErrorReportBtn: boolean = true;

  /**
   * Флаг состояния области с деталями ошибки: раскрыта\скрыта.
   * @name _isErrorDetailsExpanded
   * @type {boolean}
   * @defaultValue - true
   */
  private _isErrorDetailsExpanded: boolean = true;

  /**
   * Сэк-трэйс ошибки или иные детали.
   * @name errorDetails
   * @type {string}
   */
  public errorDetails: string;

  /**
   * Емиттер клика по кнопке "Вернуться в систему".
   * @name goBackClick
   * @type {EventEmitter<DxAppEvent>}
   */
  @Output()
  public goBackClick: EventEmitter<DxAppEvent> = new EventEmitter();

  /**
   * Емиттер клика по кнопке "Отправить отчет в техподдержку".
   * @name submitErrorReportClick
   * @type {EventEmitter<DxAppEvent>}
   */
  @Output()
  public submitErrorReportClick: EventEmitter<DxAppEvent> = new EventEmitter();

  constructor() {}


  @Input()
  public set error(value: DxAppError) {
    this._error = value;
  }

  ngOnInit(): void {
    if(this._error) {
      this.errorTitle = this._error.name;
      this.errorMessage = this._error.message;
      this.errorDetails = this._error.stackTrace;
    }
  }

  ngOnDestroy(): void { }

  /** Сворачивает\разворачивает область с деталями ошибки. */
  public onToggleErrorDetails(): void {
    this._isErrorDetailsExpanded = !this._isErrorDetailsExpanded;
  }

  get isErrorDetailsExpanded(): boolean {
    return this._isErrorDetailsExpanded;
  }

  /**
   * Обрабатывает клик по кнопке "Вернуться в систему".
   * В результат происходит выброс события через эммиттер `goBackClick`.
   * @publicApi
   */
  public onGoBackToApp(): void {
    this.goBackClick.emit(new DxAppEvent('go-back-btn'));
  }

  /**
   * Обрабатывает клик по кнопке "Отправить отчет в техподдержку".
   * В результат происходит выброс события через эммиттер `submitErrorReportClick`.
   * @publicApi
   */
  public onSubmitErrorReport(): void {
    this.submitErrorReportClick.emit(new DxAppEvent('submit-error-report-btn', this._error));
  }
}
